import { API, graphqlOperation } from "aws-amplify";
import React, { useState } from "react";
import { HorizontalBar } from "react-chartjs-2-old";
import { isMobile } from "react-device-detect";
import ReactTooltip from "react-tooltip";
import Loading from "_shared/components/Loading/Loading";
import "./IVolLandscape.scss";

let sortedListName = [];
let ivol = [];
let dataTip1D = "";
let dataTip5D = "";
let dataTip1M = "";
let dataTip3M = "";

export default function IVolLandscape(props) {
  const [period, setPeriod] = useState("1D");
  const [data, setData] = useState([]);
  const [hoveredBarInfo, setHoveredBarInfo] = useState({});
  const [handler, setHandler] = React.useState("");

  let highestIVol = 0;
  let lowestIVol = 0;

  const Chart = React.useRef();

  React.useEffect(() => {
    ReactTooltip.rebuild();
  }, [data]);

  React.useEffect(() => {
    const handling = (e) => setHandler({ matches: e.matches });
    window
      .matchMedia("(max-width: 480px)")
      .addEventListener("change", handling);
  }, [handler]);

  React.useEffect(() => {
    async function getData() {
      const response = await API.graphql(
        graphqlOperation(`{
          ticker(where: {panel_id: {_eq:"${props.tab ? props.tab.id : ""}"}}) {
              ticker
              data{
                name
              }
          }}`),
      );
      setData(response.data.ticker);
      getIntradayData(response.data.ticker);
      setHoveredBarInfo({});
    }
    getData();
  }, [props.tab]);

  // Mobile scrolling up/down arrows
  // React.useEffect(() => {
  //   if (isMobile) {
  //     setScrollDownArrow(true);
  //     setScrollUpArrow(true);
  //   }
  // }, []);

  const dataTipDate = (date, subtractDays) => {
    const newDate = new Date(
      date.setDate(date.getDate() - subtractDays),
    ).toLocaleDateString("fr-CA");
    return newDate.charAt(5) === "0"
      ? "4:30PM " + newDate.substring(6) + "-" + newDate.substring(0, 4)
      : "4:30PM " + newDate.substring(5) + "-" + newDate.substring(0, 4);
  };

  const formatDate = (date) => {
    let temp = new Date(date);
    if (date) {
      const subtractDay =
        period === "1D" ? 0 : period === "5D" ? 7 : period === "1M" ? 30 : 90;
      date = temp.setDate(temp.getDate() - subtractDay);
      date = new Date(date).toLocaleDateString("fr-CA");

      let newDate =
        date.charAt(5) === "0"
          ? date.substring(6) + "-" + date.substring(0, 4)
          : date.substring(5) + "-" + date.substring(0, 4);
      if (period === "1D") {
        temp = new Date(date);
        dataTip1D = dataTipDate(temp, -1);
        temp = new Date(date);
        dataTip5D = dataTipDate(temp, 6);
        temp = new Date(date);
        dataTip1M = dataTipDate(temp, 29);
        temp = new Date(date);
        dataTip3M = dataTipDate(temp, 89);
        date = data[0]?.data?.timestamp;
        let formatTime =
          parseInt(
            date?.substring(date.indexOf("T") + 1, date.indexOf("T") + 6),
          ) - 5;
        if (formatTime < 12) formatTime += ":30AM";
        else if (formatTime === 12) formatTime += ":30PM";
        else formatTime = (formatTime % 12) + ":30PM";
        newDate = formatTime + " " + newDate;
      } else newDate = "4:30PM " + newDate;

      return newDate;
    }
  };

  async function getIntradayData(tickerList) {
    let todayDate = new Date();
    todayDate = todayDate.toLocaleDateString("fr-CA");
    let fiveDayAgoDate = new Date();
    fiveDayAgoDate = fiveDayAgoDate.setDate(fiveDayAgoDate.getDate() - 5);
    fiveDayAgoDate = new Date(fiveDayAgoDate).toLocaleDateString("fr-CA");
    const response = tickerList.map(
      async (obj) =>
        await API.graphql(
          graphqlOperation(`{
        get_charting_data(object: {data: {ticker:"${obj.ticker}", from: "${fiveDayAgoDate}", to: "${todayDate}", interval: "daily", fields: ["timestamp", "CurrImpVolDiscPrem"]}}) {
          data
        }
      }`),
        ),
    );

    const resolveResponse = await Promise.all(response).then((obj) => obj);
    // eslint-disable-next-line
    let temp = tickerList.map((obj, i) => {
      const chartData = resolveResponse[i].data.get_charting_data.data;
      const currentValue = chartData[0];
      try {
        obj.data.algo_CurrImpVolDiscPrem = currentValue.curr_imp_vol_disc_prem;
        obj.data.algo_CurrImpVolDiscPrem1D =
          chartData[chartData.length - 2].curr_imp_vol_disc_prem;
        obj.data.algo_CurrImpVolDiscPrem7D =
          currentValue.curr_imp_vol_disc_prem_7d;
        obj.data.algo_CurrImpVolDiscPrem30D =
          currentValue.curr_imp_vol_disc_prem_30d;
        obj.data.algo_CurrImpVolDiscPrem90D =
          currentValue.curr_imp_vol_disc_prem_90d;
        obj.data.timestamp = currentValue.timestamp;
        return obj;
      } catch (err) {
        console.log(err);
      }
    });
    console.log(resolveResponse);
    setData(temp);
  }

  const barData = () => {
    ivol = [];

    if (period === "1D") {
      data.map((ticker, i) => {
        //check if any values are undefined before calculating ivol
        if (ticker?.data?.algo_CurrImpVolDiscPrem) {
          ivol.push({
            ivol: parseInt(ticker.data.algo_CurrImpVolDiscPrem * 100),
            name: ticker.data.name,
            ticker: ticker.ticker,
            timestamp: formatDate(ticker.data.timestamp),
            barColor:
              parseInt(ticker.data.algo_CurrImpVolDiscPrem * 100) < -10
                ? "#D33541"
                : parseInt(ticker.data.algo_CurrImpVolDiscPrem * 100) > 10
                ? "#5ec72e"
                : "#666",
          });
        }
        return null;
      });
    } else {
      for (let i = 0; i < sortedListName.length; i++)
        for (let j = 0; j < data.length; j++) {
          if (period === "5D" && data[j]?.data?.algo_CurrImpVolDiscPrem7D) {
            //check if any values are undefined before calculating ivol
            if (data[j]?.ticker === sortedListName[i]?.ticker) {
              ivol[i] = {
                ivol: parseInt(data[j].data.algo_CurrImpVolDiscPrem7D * 100),
                name: data[j].data.name,
                ticker: data[j].ticker,
                timestamp: formatDate(data[j].data.timestamp),
                barColor:
                  data[j].data.algo_CurrImpVolDiscPrem7D * 100 < -10
                    ? "#D33541"
                    : data[j].data.algo_CurrImpVolDiscPrem7D * 100 > 10
                    ? "#5ec72e"
                    : "#666",
              };
            }
          }
          if (period === "1M" && data[j]?.data?.algo_CurrImpVolDiscPrem30D) {
            //check if any values are undefined before calculating ivol
            if (data[j]?.ticker === sortedListName[i]?.ticker) {
              ivol[i] = {
                ivol: parseInt(data[j].data.algo_CurrImpVolDiscPrem30D * 100),
                name: data[j].data.name,
                ticker: data[j].ticker,
                timestamp: formatDate(data[j].data.timestamp),
                barColor:
                  data[j].data.algo_CurrImpVolDiscPrem30D * 100 < -10
                    ? "#D33541"
                    : data[j].data.algo_CurrImpVolDiscPrem30D * 100 > 10
                    ? "#5ec72e"
                    : "#666",
              };
            }
          }

          if (period === "3M" && data[j]?.data?.algo_CurrImpVolDiscPrem1D) {
            //check if any values are undefined before calculating ivol
            if (data[j]?.ticker === sortedListName[i]?.ticker) {
              ivol[i] = {
                ivol: parseInt(data[j].data.algo_CurrImpVolDiscPrem90D * 100),
                name: data[j].data.name,
                ticker: data[j].ticker,
                timestamp: formatDate(data[j].data.timestamp),
                barColor:
                  data[j].data.algo_CurrImpVolDiscPrem90D * 100 < -10
                    ? "#D33541"
                    : data[j].data.algo_CurrImpVolDiscPrem90D * 100 > 10
                    ? "#5ec72e"
                    : "#666",
              };
            }
          }
        }
    }

    if (period === "1D") {
      ivol = ivol.sort((a, b) => b.ivol - a.ivol);
      sortedListName = ivol.map((ticker) => ({
        ticker: ticker.ticker,
        name: ticker.name,
      }));
    }

    //there is a bug where the smallest and largest bars get cutoff when the label gets displayed
    //find the highest and lowest ivol values and increase their value in order to shrink the bar
    //this gives room for the label to be displayed
    ivol.map((obj) => {
      if (Number(obj.ivol) > highestIVol) highestIVol = Number(obj.ivol) + 5;
      if (Number(obj.ivol) < lowestIVol) lowestIVol = Number(obj.ivol) - 10;
      return obj;
    });

    ivol.push({
      ivol: highestIVol,
      name: "",
      ticker: "",
      barColor: "transparent",
    });
    ivol.push({
      ivol: lowestIVol,
      name: "",
      ticker: "",
      barColor: "transparent",
    });
    // ivol.unshift({
    //   ivol: "",
    //   name: "Description",
    //   ticker: "Ticker",
    //   barColor: "transparent",
    // });
  };

  barData();

  return data.length !== 0 ? (
    <div className="dashboard-content  ivol-landscape">
      <div
        style={{
          textAlign: "center",
          marginTop: 20,
          fontSize: 18,
          color: "white",
        }}
      >
        IVOL Landscape
      </div>
      <div
        style={{
          paddingTop: 3,
          color: "white",
          fontSize: 12,
          textAlign: "center",
          fontStyle: "italic",
        }}
      >
        <p>
          30D ATM Put Implied Volatility / 30D Price Volatility - 1 = Implied
          Volatility (Discount) / Premium
        </p>
        <p>Data updates after market close</p>
        <div style={{ height: 5 }} />
        <p>
          Premiums (green) = investors are fearful, be an opportunistic buyer.
        </p>
        <p>
          Discounts (red) = investors are complacent, be an opportunistic
          seller.
        </p>
      </div>
      <div
        className="cross-asset-class-volatility"
        style={{ display: "flex", justifyContent: "center" }}
      >
        <div
          className="buttons"
          style={
            window.matchMedia("(max-width: 480px)").matches
              ? { width: 280 }
              : null
          }
        >
          <div
            data-tip={dataTip1D}
            onClick={() => {
              setPeriod("1D");
              setHoveredBarInfo({});
            }}
            className={`button 1D ${
              period === "1D" || period === "Daily" ? "selected" : ""
            }`}
          >
            1D
          </div>
          <div
            data-tip={dataTip5D}
            onClick={() => {
              setPeriod("5D");
              setHoveredBarInfo({});
            }}
            className={`button 5D ${period === "5D" ? "selected" : ""}`}
          >
            1W
          </div>
          <div
            data-tip={dataTip1M}
            onClick={() => {
              setPeriod("1M");
              setHoveredBarInfo({});
            }}
            className={`button 1M ${period === "1M" ? "selected" : ""}`}
          >
            1M
          </div>
          <div
            data-tip={dataTip3M}
            onClick={() => {
              setPeriod("3M");
              setHoveredBarInfo({});
            }}
            className={`button 3M ${period === "3M" ? "selected" : ""}`}
          >
            3M
          </div>
        </div>
      </div>
      <div
        style={{
          display: "flex",
          width: "100vw",
        }}
      >
        <div className="canvas">
          {ivol[hoveredBarInfo._index] && (
            <div
              style={{
                position: "absolute",
                border: "1px solid " + ivol[hoveredBarInfo._index]?.barColor,
                borderRadius: 5,
                background: "hsla(0, 0%, 0%, .8)",
                padding: "3px 5px",
                color: "white",
                fontSize: 12,
                top: hoveredBarInfo._model?.y - 77,
                left:
                  ivol[hoveredBarInfo._index]?.ivol < 0
                    ? hoveredBarInfo._model?.x
                    : hoveredBarInfo._model?.x -
                      ivol[hoveredBarInfo._index]?.name.length * 7.5,
              }}
            >
              <div>
                {"4:30PM" + ivol[hoveredBarInfo._index]?.timestamp.substring(6)}
              </div>
              <div style={{ textAlign: "center" }}>
                {ivol[hoveredBarInfo._index]?.name}
              </div>
              <div style={{ display: "flex", justifyContent: "space-between" }}>
                <div>{ivol[hoveredBarInfo._index]?.ivol + "% "}</div>
                <div>{ivol[hoveredBarInfo._index]?.ticker}</div>
              </div>
            </div>
          )}

          <HorizontalBar
            ref={Chart}
            data={{
              labels: ivol.map((ticker) =>
                !window.matchMedia("(max-width: 480px)").matches
                  ? ticker.name
                  : " ",
              ),
              datasets: [
                {
                  data: ivol.map((ticker) => ticker.ivol),
                  backgroundColor: ivol.map((ticker) => ticker.barColor),
                },
              ],
            }}
            options={{
              onHover: (_, elements) => {
                if (elements[0] && ivol.length - 2 > elements[0]._index)
                  setHoveredBarInfo(elements[0]);
                else setHoveredBarInfo({});
              },
              tooltips: {
                enabled: false,
              },
              responsive: true,
              maintainAspectRatio: false,
              legend: { display: false },
              scales: {
                xAxes: [
                  {
                    ticks: {
                      fontFamily: "capsule",
                      fontColor: "#bbb8b8",
                      userCallback: function (value, index) {
                        return value + "%";
                      },
                    },
                  },
                ],
                yAxes: [
                  {
                    ticks: {
                      fontFamily: "capsule",
                      fontColor: "#bbb8b8",
                      userCallback: function (value, index) {
                        try {
                          let whiteSpace = "";
                          for (
                            let i = 0;
                            i < 30 - ivol[index]["ticker"].length;
                            i++
                          )
                            whiteSpace += " ";
                          return value + whiteSpace + ivol[index]["ticker"];
                        } catch (err) {
                          console.log(err);
                        }
                      },
                    },
                  },
                ],
              },
              hover: { animationDuration: 0 },
              animation: {
                duration: 1,
                onComplete: function () {
                  var chartInstance = this.chart,
                    ctx = chartInstance.ctx;
                  ctx.textAlign = "center";
                  ctx.fillStyle = "white";
                  ctx.textBaseline = "bottom";
                  ctx.font = "bold 9pt arial";
                  this.data.datasets.forEach(function (dataset, i) {
                    var meta = chartInstance.controller.getDatasetMeta(i);
                    meta.data.forEach(function (bar, index) {
                      var data = dataset.data[index];
                      data = !meta.hidden ? data : "";
                      if (index < dataset.data.length - 2 && data !== "")
                        if (Number(data) < 0) {
                          ctx.fillText(
                            data + "%",
                            bar._model.x - 20,
                            bar._model.y + 8,
                          );
                        } else {
                          ctx.fillText(
                            data + "%",
                            bar._model.x + 20,
                            bar._model.y + 8,
                          );
                        }
                    });
                  });
                },
              },
            }}
          />
        </div>
      </div>

      <div
        style={{
          color: "#666",
          fontSize: 12,
          textAlign: "center",
          position: "relative",
          top: 55,
          height: 100,
        }}
      >
        {false ? "" : "Data Source: Bloomberg L.P."}
      </div>
      <div
        className="scroll-arrow"
        style={{
          position: "fixed",
          bottom: 10,
          width: "100%",
          paddingRight: "70px",
          left: "auto",
          right: "auto",
          color: "#bbb8b8",
          fontSize: "40px",
          opacity: "30%",
          cursor: "pointer",
        }}
      >
        {isMobile ? (
          <div>
            <i
              className="fa fa-arrow-circle-up"
              onClick={() => {
                window.scrollTo({
                  top: window.scrollY - 90,
                  behavior: "smooth",
                });
              }}
            ></i>
            &nbsp;&nbsp;
            <i
              className="fa fa-arrow-circle-down"
              onClick={() => {
                window.scrollTo({
                  top: window.scrollY + 90,
                  behavior: "smooth",
                });
              }}
            ></i>
          </div>
        ) : (
          <div></div>
        )}
      </div>
    </div>
  ) : (
    <div
      style={{
        display: "flex",
        justifyContent: "center",
        height: "80vh",
        alignItems: "center",
      }}
    >
      <Loading variant="inner" />
    </div>
  );
}
